import React from "react";
import { Box, Button } from "@mui/joy";
import { useAuth } from "../../contexts/api";
import type { CompanyRole } from "../../api/auth/Auth.typed";
import CommonModal from "../common/CommonModal";
import { colorTokens } from "../../styles/globalStyles";

export default function CompanySelectModal() {
  const { isCompanyModalOpen, companyOptions, selectCompany, dismissCompanyModal } = useAuth();
  const didAutoSelectRef = React.useRef(false);

  React.useEffect(() => {
    if (didAutoSelectRef.current) return;
    if (isCompanyModalOpen && (companyOptions || []).length === 1) {
      didAutoSelectRef.current = true;
      const only = (companyOptions as CompanyRole[])[0];
      selectCompany(only.company?.id);
    }
  }, [isCompanyModalOpen, companyOptions, selectCompany]);

  // If zero company or while auto-selecting a single one, do not render the modal
  if ((companyOptions || []).length <= 1) {
    return null;
  }

  return (
    <CommonModal
      open={!!isCompanyModalOpen}
      onClose={dismissCompanyModal}
      title="Sélectionnez l'entreprise"
      size="md"
      fitContentHeight
    >
      <Box sx={{ display: "grid", gap: 1 }}>
        {(companyOptions || []).map((cr: CompanyRole) => (
          <Button
            key={cr.company?.id}
            variant="soft"
            onClick={() => selectCompany(cr.company?.id)}
            sx={{
              justifyContent: "flex-start",
              backgroundColor: colorTokens.bg.app,
              color: colorTokens.text.primary,
              width: "100%",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              "&:hover": { backgroundColor: colorTokens.bg.surface },
            }}
          >
            {cr.company?.name ?? "Société"}
          </Button>
        ))}
      </Box>
    </CommonModal>
  );
}
